import { render } from "./TasksManager.vue?vue&type=template&id=f56af282"
import script from "./TasksManager.vue?vue&type=script&lang=js"
export * from "./TasksManager.vue?vue&type=script&lang=js"

import "./TasksManager.vue?vue&type=style&index=0&id=f56af282&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__